module.exports = __webpack_public_path__ + "img/94.99700fd1.jpg";